import React from "react";
import { useTranslation } from "react-i18next";

import { IosDevice } from "./IosDevice";
import { MalluAppScreen } from "./MalluAppScreen";
import "./mallu.css";

/**
 * Celular estático com o app Mallu Pay — substitui as artes de outras marcas
 * nas páginas internas (Team / Gallery). Decorativo (aria-hidden).
 */
export const MalluPhone = ({ className = "" }) => {
  const { t } = useTranslation("malluLanding");
  return (
    <div className={`pp-phone-static ${className}`.trim()} aria-hidden="true">
      <div className="pp-phone-scale">
        <IosDevice>
          <MalluAppScreen t={t} />
        </IosDevice>
      </div>
    </div>
  );
};
